/* SHOP AFRICA USA — Stable desktop mega-menu hover */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var items = Array.prototype.slice.call(document.querySelectorAll('.nav__item--has-mega'));
    if (!items.length) return;

    var closeDelay = 320;

    function getTrigger(item) {
      for (var i = 0; i < item.children.length; i++) {
        if (item.children[i].matches && item.children[i].matches('a[aria-haspopup]')) {
          return item.children[i];
        }
      }
      return item.querySelector('a[aria-haspopup]');
    }

    function closeItem(item) {
      clearTimeout(item.__megaTimer);
      item.classList.remove('is-mega-open');
      var trigger = getTrigger(item);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function closeAll(except) {
      items.forEach(function (item) {
        if (item !== except) closeItem(item);
      });
    }

    function openItem(item) {
      clearTimeout(item.__megaTimer);
      closeAll(item);
      item.classList.add('is-mega-open');
      var trigger = getTrigger(item);
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose(item) {
      clearTimeout(item.__megaTimer);
      item.__megaTimer = setTimeout(function () {
        closeItem(item);
      }, closeDelay);
    }

    items.forEach(function (item) {
      var trigger = getTrigger(item);
      var mega = item.querySelector('.mega');
      if (!trigger || !mega) return;

      item.addEventListener('mouseenter', function () { openItem(item); });
      item.addEventListener('mouseleave', function () { scheduleClose(item); });
      mega.addEventListener('mouseenter', function () { openItem(item); });
      mega.addEventListener('mouseleave', function () { scheduleClose(item); });

      item.addEventListener('focusin', function () { openItem(item); });
      item.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!item.contains(document.activeElement)) scheduleClose(item);
        }, 0);
      });

      item.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeItem(item);
          trigger.focus();
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.nav__item--has-mega')) {
        closeAll();
      }
    });
  });
})();
